<div class="signature-container" #signatureDiv>
  <signature-pad
    #signaturePad
    class="signature-pad"
    (drawStart)="drawStart()"
    (window:resize)="resizeSignaturePad()"
  ></signature-pad>
</div>
